import React, { useEffect, useState, useRef } from 'react';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import { useForm } from "react-hook-form";
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HttpHelper from '../../service/httpService'
import DashboardWrapper from './DashboardWrapper';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { CiEdit } from "react-icons/ci";
import { AiOutlineDelete } from "react-icons/ai";
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";


const SecurityObjectName = 'Website.KeyFeatures';

const DashboardKeyFeatures = (props) => {
    const {
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,
        Outdent,
        OrderedList,
        UnorderedList,
        Undo,
        Redo,
        FontSize,FontName,
        FormatBlock,
        Link,
        Unlink,
        ViewHtml,
        InsertTable,
        AddRowBefore,
        AddRowAfter,
        AddColumnBefore,
        AddColumnAfter,
        DeleteRow,
        DeleteColumn,
        DeleteTable,
        MergeCells,
        SplitCell,
    } = EditorTools;


    const editor = useRef();
    const [contentData, setContentData] = useState("");

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const [keyFeature, setKeyFeature] = useState({});
    const [type, setType] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const formRef = useRef();
    const [isEditing, setIsEditing] = useState(false);
    const [KeyfeatureImage, setKeyfeatureImage] = useState(null);
    const [factIdUpdate, setFactIdUpdate] = useState();
    const [fileIdUpdate, setFileIdUpdate] = useState();
    const [fileDetailsUpdate, setFileDetailsUpdate] = useState();
    const [rowVersion, setRowVersion] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');
    const [imageCurrentShow, setImageCurrentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);
    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');

    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (isEditing === true) {
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("KeyFeature/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        if (factIdUpdate !== '') {

                            KeyFeaturesUpdate(data, factIdUpdate, data.FileId, response.data[0], true);
                        }
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else {
                KeyFeaturesUpdate(data, factIdUpdate, fileIdUpdate, fileDetailsUpdate);
                //props.showToast('error', 'Please add image');
            }
        } else {
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("KeyFeature/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        KeyFeatureAdd(data, true)
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else {
                KeyFeatureAdd(data)
            }
        }

    };

    const KeyFeatureAdd = async (data, imageUpdate) => {
        await HttpHelper.post("KeyFeature", data).then((response) => {
            setLoaderApi(false);
            setPopupAddEdit(false);
            props.showToast('success', 'Record Added Succesfully');
            BlankFillDetails();
            GetKeyFeatures();
        }).catch((error) => {
            if (imageUpdate === true) {
                DeleteUploadedFile(data.FileId)
            }
            console.log(error);
        })
    }

    const KeyFeaturesUpdate = async (data, factIdUpdate, fileId, fileDetails, imgDelete) => {
        Object.assign(data, { rowVersion: rowVersion }, { primaryKeyEncrypted: primaryKeyEncrypted }, { FactId: factIdUpdate }, { FileId: fileId }, { file: fileDetails });
        console.log(data)

        await HttpHelper.put("KeyFeature", data).then((response) => {
            setLoaderApi(false);
            setPopupAddEdit(false);
            if (response.status === 200) {
            } else {
                console.log('error while uploading the image');
            }
            BlankFillDetails();
            props.showToast('success', 'Record Updated Succesfully');
            GetKeyFeatures();
        }).catch((error) => {
            if (imgDelete === true) {
                DeleteUploadedFile(data.FileId)
            }
            console.log(error);
        })
    }

    const GetKeyFeatures = async (data) => {
        setLoaderApi(true);
        await HttpHelper.get("KeyFeature", data).then((response) => {
            setKeyFeature(response.data.data);
            getAllPermission();
            setLoaderApi(false);
        }).catch((error) => {
            console.log(error);
        })

    }
    const DeleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("KeyFeature/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }
    const UpdateEditKeyFeature = async (elem) => {

        setPopupAddEdit(true);
        setLoaderApi(true);

        setIsEditing(true);
        setShowLoader(true);

        await HttpHelper.get("KeyFeature/" + elem).then((response) => {
            setValue('Heading', response.data.heading);
            setValue('ImgHeading', response.data.imgHeading);
            setValue('Title', response.data.title);
            setValue('SubTitle', response.data.subTitle);
            setValue('Content', response.data.content);
            setValue('file', '');
            setValue('Type', response.data.type);
            setType(response.data.type);
            setValue('Order', response.data.order);
            setContentData(response.data.content);
            setFactIdUpdate(response.data.factId);
            setRowVersion(response.data.rowVersion);
            setFileIdUpdate(response.data.fileId);
            setFileDetailsUpdate(response.data.file);
            setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted)
            if (response.data.file !== null) {
                console.log(response.data.file.fileUrl)
                setKeyfeatureImage(response.data.file.fileUrl)
            } else {
                setKeyfeatureImage(null)
            }
            setShowLoader(false);
            accordianStatusHandle('1');

            setPopupAddEdit(true);
            setLoaderApi(false);

        }).catch((error) => {
            setShowLoader(false);
            console.log(error);
        })
    }
    const DeleteKeyFeatureById = (id, fileId) => {
        swal("Are you sure, you want to delete this KeyFeature?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    setIsEditing(false);
                    formRef.current.reset();
                    await HttpHelper.delete("KeyFeature/" + id).then((response) => {
                        props.showToast('success', 'KeyFeature Deleted successfully');
                        GetKeyFeatures();
                        DeleteUploadedFile(fileId);
                    }).catch((error) => {
                        props.showToast('error', error.response.data);
                        console.log(error);
                    })
                }
            }
            );
    }
    const BlankFillDetails = () => {
        setValue('Heading', '');
        setValue('Order', '');
        setValue('ImgHeading', '');
        setValue('file', '')
        setValue('Title', '');
        setValue('Content', '');
        setValue('Type', '');
        setType('');
        setValue('SubTitle', '');
        setFactIdUpdate('');
        setRowVersion('');
        setPrimaryKeyEncrypted('')
        setShowLoader(false)
        setFileIdUpdate('');
        setFileDetailsUpdate('');
        setContentData('')
    }
    const accordianStatusHandle = (elem) => {

        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }
    useEffect(() => {
        GetKeyFeatures();
        setIsEditing(true);
    }, []);

    return (
        <>
            <DashboardWrapper>
                <ToastContainer />
                <div className="DashboardWrapperChild">
                    <Sidebar />
                    <div className="contentWrapper">
                        <HeaderDashboard title="Key Features List" />
                        <div className="container-fluid mt-80 p-0">
                            <div className="row">
                                <p><b>Note:-</b> Key Features image size should be Width : 350px & Height : 191px</p>
                                {hasAddPermissionUser == true ? <div className="col-auto">
                                    <button onClick={() => {
                                        setPopupAddEdit(true);
                                        BlankFillDetails();
                                        accordianStatusHandle('1');
                                        setIsEditing(false);
                                    }} className="btn btnSave">Add Key Features</button>
                                </div> : ''}
                                <div className="col-md-12 mb-2">
                                </div>


                                {hasAddPermissionUser == true && loaderApi == false ?
                                    <div className="col-md-12 mb-2 table-responsive">
                                        <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                            <table className="table tableCustomized table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            Order
                                                        </th>
                                                        <th>
                                                            Title
                                                        </th>
                                                        <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                            Image
                                                        </th>
                                                        <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                            Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        keyFeature.length > 0 && keyFeature.map((elem, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{elem.title}</td>
                                                                    <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                        {
                                                                            elem.file && elem.file.fileUrl ? < img src={elem.file.fileUrl} width="30" height="30" /> : null
                                                                        }
                                                                    </td>
                                                                    <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                        {hasEditPermissionUser || hasDeletePermissionUser ?
                                                                            <div className="editIcons" style={{ display: 'flow' }}>

                                                                                {hasEditPermissionUser == true ? <CiEdit onClick={() => { UpdateEditKeyFeature(elem.primaryKeyEncrypted) }} /> : ''}
                                                                                {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => { DeleteKeyFeatureById(elem.featureId, elem.fileId) }} /> : ''}

                                                                            </div> : ''}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                            <g fill="none" fill-rule="evenodd">
                                                <g transform="translate(1 1)" stroke-width="2">
                                                    <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                                    <path d="M36 18c0-9.94-8.06-18-18-18">
                                                        <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                                    </path>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                    <div className="crossPopup" onClick={() => {
                        setShowImgPopup(false);
                        setImageCurrentShow('');
                    }}>
                        <RxCross1 />
                    </div>
                    <img src={imageCurrentShow} />
                </div>

                {hasEditPermissionUser || hasAddPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                    <div className="popupEditAndAddForm">
                        <div className="popupEditAndAddFormCloseButton" onClick={() => {
                            setPopupAddEdit(false);
                            setIsEditing(true);
                        }} >
                            <RxCross2 />
                        </div>

                        {loaderApi == true ? <div className="loaderApi">
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="2">
                                        <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                        <path d="M36 18c0-9.94-8.06-18-18-18">
                                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                        </path>
                                    </g>
                                </g>
                            </svg>
                        </div> : <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                            <div className="cardBox">
                                <h4>{isEditing === true ? "Update Key Features" : "Create Key Features"}</h4>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Title: {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                        <input className="border w-100" {...register("Title", { required: true })} required="true" placeholder="Title"></input>
                                        {errors.Title?.type === 'required' && <p className="text-danger" role="alert">Title is required</p>}

                                        <div className={`${type == "Title" ? '' : 'd-none'}`}>
                                            <label  >Sub Title: </label>
                                            <input className="border w-100" {...register("SubTitle")} placeholder="Sub Title"></input>
                                            <input className="d-none border w-100" {...register("Type")} ></input>
                                        </div>
                                        <div className={`${type == "Title" ? 'd-none' : ''}`}>

                                            <label >Order: </label>
                                            <input className="border w-100" {...register("Order", { required: true })} placeholder="Order"></input>

                                            <label c>File : {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                            <br />
                                            <label >{fileDetailsUpdate != null ? fileDetailsUpdate.originalFileName : ''} </label>
                                            <input className="border mb-2 w-100 is-invalid" type="file"  {...register('file', { required: isEditing === true ? false : true })} />
                                            {errors.file?.type === 'required' && <p className="text-danger" role="alert">Image is required</p>}

                                            <label >Content : {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                            <Editor className="border" placeholder="Description"
                                                tools={[
                                                    [Bold, Italic, Underline, Strikethrough],
                                                    [Subscript, Superscript],
                                                    [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                    [Indent, Outdent],
                                                    [OrderedList, UnorderedList],
                                                    FontSize,FontName,
                                                    FormatBlock,
                                                    [Undo, Redo],
                                                    [Link, Unlink, ViewHtml],
                                                    [InsertTable],
                                                    [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                                    [DeleteRow, DeleteColumn, DeleteTable],
                                                    [MergeCells, SplitCell],
                                                ]}
                                                ref={editor}
                                                defaultContent={contentData}
                                                onChange={(e) => {
                                                    const regex = /(<([^>]+)>)/gi;
                                                    const result = e.html.replace(regex, "");
                                                    if (result.length > 0)
                                                        setValue('Content', e.html);
                                                    else
                                                        setValue('Content', null);

                                                }}
                                            />
                                            <textarea className="border d-none" {...register("Content", { required: true })} placeholder="Content"></textarea>
                                            {errors.Content?.type === 'required' && <p className="text-danger" role="alert">Content is required</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-12 d-flex justify-content-end mt-3">
                                        <div>
                                            <button className="btn btnSave mt-2">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>}

                    </div>
                </div> : ''}

            </DashboardWrapper >
        </>
    )
}

export default DashboardKeyFeatures;